<template>
    <div
        v-if="isComponentReady"
        :class="wrapperClasses"
        class="l-ss-c-completions">
        <completions-wrapper
            :completions="completions"
            :query="query"
            :show-all-visible="widgetComplex"
            :taps-complitions="tapsCompletions"
            :is-show-signature="isShowSignature"
            @click="handleClick"
            @search-all="$emit('search-all')"
            @handleTagsClick="args => $emit('search-input-change', args)"
            @preview-tab-click="(value) => $emit('preview-tab-click', value)"
            @reset-query="$emit('reset-query')"
            @add-to-cart-click="$emit('add-to-cart-click', $event)"
            @remove-from-cart-click="$emit('remove-from-cart-click', $event)"
            @remove-history="(params) => $emit('remove-history', params)"/>
    </div>
</template>

<script>
    import { installPlugins } from '../core/plugins';
    import CompletionsMixin from '../core/mixins/completions';
    import RootComponentMixin from '../core/mixins/root-component';
    import CompletionsMethods from '../core/mixins/completions-methods';
    import CompletionsWrapper from '../core/components/completions/completions-wrapper.vue';

    installPlugins();

    export default {
        components: {
            CompletionsWrapper,
        },
        mixins: [
            CompletionsMethods,
            CompletionsMixin,
        ],

        props: {
            ...RootComponentMixin.props,
            ...CompletionsMixin.props,
            completions: {
                type: Array,
                default: () => ([]),
            },
            query: {
                type: String,
                default: '',
            },
        },
        computed: {
            ...RootComponentMixin.computed,
            searchResultsWidgetExists() {
                return this.$instances.some(instance => instance.type === 'search-results');
            },
            widgetComplex() {
                return !!this.instance?.settings?.widgetComplex;
            },
        },
        methods: {
            handleClick(data) {
                this.store.commit('ui/SET_PROPERTY', { key: 'isCategorySearch', value: false });

                const handler = (completion) => {
                    const searchStateUpdates = {
                        from_completions: completion._text,
                        ...completion.search,
                    };

                    const searchStateUrl = this.instance.controller.searchStateManager.buildStateUrl(searchStateUpdates);
                    if (this.searchResultsWidgetExists) {
                        this.$emit('close');
                        this.instance.controller.handleUpdateSearchStateWithRequest(searchStateUpdates);
                    }

                    if (completion.label === 'categories') {
                        completion.search.params = [{
                            field: 'category',
                            condition: 'in',
                            options: [completion.search.categoryId],
                        }];
                    }

                    this.$emit('click-item', {
                        ...completion, // TODO: deprecated [удалить c 01.03]
                        completion: completion,
                        searchStateUrl: searchStateUrl,
                    });
                };
                this.completionClickHandler(data, handler.bind(this));
            },
        },
    };
</script>
